"use strict";

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translatePost = exports.takeOverPost = exports.removePostLock = exports.refreshPostLock = exports.reorderPosts = exports.duplicatePost = exports.emptyTrash = exports.deletePost = exports.updatePost = exports.getPost = exports.addPost = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toolkit = require("@reduxjs/toolkit");

var _rest = _interopRequireDefault(require("../api/rest"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var addPost = (0, _toolkit.createAsyncThunk)('post/add', /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args, thunkAPI) {
    var _thunkAPI$getState, source, response;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _thunkAPI$getState = thunkAPI.getState(), source = _thunkAPI$getState.cms.config.source;
            _context.next = 3;
            return (0, _rest.default)('createPost', args, source);

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
exports.addPost = addPost;
var getPost = (0, _toolkit.createAsyncThunk)('post/get', /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(args, thunkAPI) {
    var _thunkAPI$getState2, source, response;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _thunkAPI$getState2 = thunkAPI.getState(), source = _thunkAPI$getState2.cms.config.source;
            _context2.next = 3;
            return (0, _rest.default)('getPost', args, source);

          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", response);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}());
exports.getPost = getPost;
var updatePost = (0, _toolkit.createAsyncThunk)('post/update', /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(args, thunkAPI) {
    var _thunkAPI$getState3, source, response;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _thunkAPI$getState3 = thunkAPI.getState(), source = _thunkAPI$getState3.cms.config.source;
            _context3.next = 3;
            return (0, _rest.default)('updatePost', args, source);

          case 3:
            response = _context3.sent;
            return _context3.abrupt("return", response);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function (_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}());
exports.updatePost = updatePost;
var deletePost = (0, _toolkit.createAsyncThunk)('post/delete', /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(args, thunkAPI) {
    var _thunkAPI$getState4, source, response;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _thunkAPI$getState4 = thunkAPI.getState(), source = _thunkAPI$getState4.cms.config.source;
            _context4.next = 3;
            return (0, _rest.default)('deletePost', args, source);

          case 3:
            response = _context4.sent;

            if (!response) {
              _context4.next = 6;
              break;
            }

            return _context4.abrupt("return", args);

          case 6:
            return _context4.abrupt("return", response);

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function (_x7, _x8) {
    return _ref4.apply(this, arguments);
  };
}());
exports.deletePost = deletePost;
var emptyTrash = (0, _toolkit.createAsyncThunk)('post/emptyTrash', /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(args, thunkAPI) {
    var _thunkAPI$getState5, source, response;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _thunkAPI$getState5 = thunkAPI.getState(), source = _thunkAPI$getState5.cms.config.source;
            _context5.next = 3;
            return (0, _rest.default)('emptyTrash', args, source);

          case 3:
            response = _context5.sent;
            return _context5.abrupt("return", _objectSpread({
              postIDs: response
            }, args));

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function (_x9, _x10) {
    return _ref5.apply(this, arguments);
  };
}());
exports.emptyTrash = emptyTrash;
var duplicatePost = (0, _toolkit.createAsyncThunk)('post/duplicate', /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(args, thunkAPI) {
    var _thunkAPI$getState6, source, response;

    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _thunkAPI$getState6 = thunkAPI.getState(), source = _thunkAPI$getState6.cms.config.source;
            _context6.next = 3;
            return (0, _rest.default)('duplicatePost', args, source);

          case 3:
            response = _context6.sent;
            return _context6.abrupt("return", response);

          case 5:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function (_x11, _x12) {
    return _ref6.apply(this, arguments);
  };
}());
exports.duplicatePost = duplicatePost;
var reorderPosts = (0, _toolkit.createAsyncThunk)('post/reorderPosts', /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(args, thunkAPI) {
    var _thunkAPI$getState7, source, postIDs;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _thunkAPI$getState7 = thunkAPI.getState(), source = _thunkAPI$getState7.cms.config.source;
            postIDs = args.posts.reduce(function (ac, a) {
              return _objectSpread(_objectSpread({}, ac), {}, _defineProperty({}, a.id, a.order));
            }, {}); // We're not gonna wait until the function is completed to give the user an instant feedback

            (0, _rest.default)('reorderPosts', {
              postIDs: postIDs
            }, source);
            return _context7.abrupt("return", args.posts);

          case 4:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function (_x13, _x14) {
    return _ref7.apply(this, arguments);
  };
}());
exports.reorderPosts = reorderPosts;
var refreshPostLock = (0, _toolkit.createAsyncThunk)('post/refreshLock', /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(args, thunkAPI) {
    var _thunkAPI$getState8, source, response;

    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _thunkAPI$getState8 = thunkAPI.getState(), source = _thunkAPI$getState8.cms.config.source;
            _context8.next = 3;
            return (0, _rest.default)('refreshPostLock', args, source);

          case 3:
            response = _context8.sent;
            return _context8.abrupt("return", response);

          case 5:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function (_x15, _x16) {
    return _ref8.apply(this, arguments);
  };
}());
exports.refreshPostLock = refreshPostLock;
var removePostLock = (0, _toolkit.createAsyncThunk)('post/removeLock', /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(args, thunkAPI) {
    var _thunkAPI$getState9, source, response;

    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _thunkAPI$getState9 = thunkAPI.getState(), source = _thunkAPI$getState9.cms.config.source;
            _context9.next = 3;
            return (0, _rest.default)('removePostLock', args, source);

          case 3:
            response = _context9.sent;
            return _context9.abrupt("return", response);

          case 5:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function (_x17, _x18) {
    return _ref9.apply(this, arguments);
  };
}());
exports.removePostLock = removePostLock;
var takeOverPost = (0, _toolkit.createAsyncThunk)('post/takeOverPost', /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(args, thunkAPI) {
    var _thunkAPI$getState10, source, response;

    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _thunkAPI$getState10 = thunkAPI.getState(), source = _thunkAPI$getState10.cms.config.source;
            _context10.next = 3;
            return (0, _rest.default)('takeOverPost', args, source);

          case 3:
            response = _context10.sent;
            return _context10.abrupt("return", response);

          case 5:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));

  return function (_x19, _x20) {
    return _ref10.apply(this, arguments);
  };
}());
exports.takeOverPost = takeOverPost;
var translatePost = (0, _toolkit.createAsyncThunk)('post/translate', /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(args, thunkAPI) {
    var _thunkAPI$getState11, source, response;

    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _thunkAPI$getState11 = thunkAPI.getState(), source = _thunkAPI$getState11.cms.config.source;
            _context11.next = 3;
            return (0, _rest.default)('translatePost', args, source);

          case 3:
            response = _context11.sent;
            return _context11.abrupt("return", response);

          case 5:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));

  return function (_x21, _x22) {
    return _ref11.apply(this, arguments);
  };
}());
exports.translatePost = translatePost;